export default __webpack_public_path__ + "static/media/small-logo.c61a749c.svg";